// filepath: /D:/xamp8.2/htdocs/chaseit1416/resources/js/store/rootReducer.ts
import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import userListReducer from "./slices/userListSlice";
import statusesReducer from "./slices/statusesSlice";
import filterSlice from "./slices/filterSlice";
import siteSlice from "./slices/siteSlice";
import postSlice from "./slices/postSlice";
var rootReducer = combineReducers({
    user: userReducer,
    userList: userListReducer,
    statuses: statusesReducer,
    filter: filterSlice,
    site: siteSlice,
    post: postSlice,
});
export default rootReducer;
